<template>
  <InfoTextEditor
    textKey="news"
    title="Edit Client News"
    viewPermission="IngameNewsView"
    editPermission="IngameNewsEdit"
  />
</template>

<script>
import InfoTextEditor from './InfoTextEditor.vue'

export default {
  name: 'IngameNews',
  components: {
    InfoTextEditor
  }
}
</script>
